import React from "react";

import bannerImg from "../assets/images/banner/att.jpg";
import { Link } from "react-router-dom";

import "../assets/css/Hero.css";

const Hero = () => {
  return (
    <section
      id="main-slide"
      className="hero-banner"
      style={{
        backgroundImage: `url(${bannerImg})`,
      }}
    >
      <div className="hero-overlay"></div>

      <div className="container">
        <div className="slider-content">
          <div className="col-lg-7 col-md-10">
            <h1 className="slide-sub-title">
              Committed. Connected. Your Partner.
            </h1>

            <Link className="contact-banner-btn" to="/contact-us">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
